export default {
      id: "chevron-left-usage",
      viewBox: "0 0 320 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#chevron-left",
      toString: function () {
        return this.url;
      }
    }